import { createAction } from '@gef-ui/utils/fsaActions';
import equals from "ramda/es/equals";
import find from "ramda/es/find";
import length from "ramda/es/length";
import prop from "ramda/es/prop";
import toLower from "ramda/es/toLower";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { getIascFromQuery } from '@gef-ui/features/iasc/utils';
import { mergeAppContext } from '@gef-ui/redux-common/actions/appContext';
import { getUserLogon } from '@gef-ui/redux-common/selectors/appContext';
import { actionTypes as USER_ACTIONS } from '@gef-ui/cdu-user/constants';
import { getAllowedCompanies } from '@gef-ui/cdu-user/selectors';
import { getIasc } from '@gef-ui/features/iasc/actions';
import { actionTypes } from '../constants';
import { getDelegations } from '../selectors';
import { getComingFromUrl, getDelegationCookies, getOriginalUserCookies, includeExcludedUrl, pickDelegationFromUserInfoResponse, pickOtherFromUserInfoResponse, resolveDelegationUser, setComingFromUrl, setDelegationsFromQuery, setOriginalUserCookies } from '../utils';
export const continueToApplication = (_userLogin, { continueAction })=>async (dispatch, _getState, { pushFn })=>{
        const comeFromUrl = getComingFromUrl();
        try {
            getIascFromQuery() && await dispatch(getIasc(getIascFromQuery()));
        } catch (error) {
            if (error !== false) {
                pushFn({
                    route: '/login/error',
                    args: {
                        error: {
                            ...error,
                            url: comeFromUrl
                        }
                    },
                    dispatch
                });
                return Promise.resolve();
            }
        }
        let pushTo = '/';
        if (!includeExcludedUrl(comeFromUrl)) {
            pushTo = comeFromUrl;
        }
        await dispatch(continueAction(pushTo));
    };
export const fetchUserInfo = (createFetchAction)=>(dispatch)=>{
        return dispatch(createFetchAction([
            createAction(actionTypes.SAVE_DELEGATIONS, pickDelegationFromUserInfoResponse),
            createAction(USER_ACTIONS.SAVE_CDU_USER, pickOtherFromUserInfoResponse),
            (res)=>mergeAppContext({
                    originalUserInfo: pickOtherFromUserInfoResponse(res)
                })
        ]));
    };
export const fetchUserInfoWithRepresentedUser = (createFetchActionWithRepresentedUser, { representativeFor })=>(dispatch)=>{
        return dispatch(createFetchActionWithRepresentedUser([
            createAction(USER_ACTIONS.SAVE_CDU_USER, pickOtherFromUserInfoResponse)
        ], {
            login: representativeFor
        }));
    };
export const canAccessToApplication = ()=>(dispatch, getState, { pushFn })=>{
        const delegations = getDelegations(getState());
        const allowedCompanies = getAllowedCompanies(getState());
        if (isNilOrEmpty(allowedCompanies) && isNilOrEmpty(delegations)) {
            pushFn({
                route: '/login/no-access',
                args: {
                    originalUser: null
                },
                dispatch
            });
            return Promise.reject(false);
        }
        return Promise.resolve(true);
    };
export const resolveDelegations = ({ continueAction, createFetchAction, createFetchActionWithRepresentedUser, getIsOriginalUserFetchLoaded })=>async (dispatch, getState, { pushFn })=>{
        const { representativeFor } = getDelegationCookies();
        const hasOriginalUserDataLoaded = getIsOriginalUserFetchLoaded(getState());
        if (!hasOriginalUserDataLoaded) {
            await dispatch(fetchUserInfo(createFetchAction));
        }
        const hasAccess = await dispatch(canAccessToApplication());
        if (!hasAccess) {
            return Promise.resolve();
        }
        const delegations = getDelegations(getState());
        if (isNilOrEmpty(delegations) && !isNilOrEmpty(representativeFor)) {
            pushFn({
                route: '/login/no-access',
                args: {
                    originalUser: getUserLogon(getState()),
                    representativeFor
                },
                dispatch
            });
            return Promise.resolve();
        }
        if (!isNilOrEmpty(delegations)) {
            const delegationUser = find((delegation)=>equals(toLower(representativeFor), toLower(prop('userLogon', delegation))))(delegations);
            if (isNilOrEmpty(delegationUser)) {
                pushFn({
                    route: '/login/no-access',
                    args: {
                        originalUser: getUserLogon(getState()),
                        representativeFor
                    },
                    dispatch
                });
                return Promise.resolve();
            }
        }
        await dispatch(fetchUserInfoWithRepresentedUser(createFetchActionWithRepresentedUser, {
            representativeFor
        }));
        dispatch(continueToApplication(representativeFor, {
            continueAction
        }));
    };
export const initDelegationScreen = ({ continueAction, createFetchAction })=>async (dispatch, getState, { pushFn })=>{
        await dispatch(fetchUserInfo(createFetchAction));
        const hasAccess = await dispatch(canAccessToApplication());
        if (!hasAccess) {
            return Promise.resolve();
        }
        const delegations = getDelegations(getState());
        const allowedCompanies = getAllowedCompanies(getState());
        if (isNilOrEmpty(delegations) && length(allowedCompanies) === 1) {
            const login = getUserLogon(getState());
            setOriginalUserCookies(login);
            dispatch(continueToApplication(login, {
                continueAction
            }));
            return Promise.resolve();
        }
        await pushFn({
            route: '/delegations',
            dispatch
        });
    };
export const initAppWithDelegation = ({ continueAction, createFetchAction, createFetchActionWithRepresentedUser, getIsOriginalUserFetchLoaded })=>async (dispatch, getState)=>{
        setComingFromUrl();
        setDelegationsFromQuery();
        const userLoginFromToken = getUserLogon(getState());
        resolveDelegationUser(userLoginFromToken);
        const { originalUser } = getOriginalUserCookies() || {};
        const { representativeFor } = getDelegationCookies() || {};
        if (originalUser) {
            await dispatch(fetchUserInfo(createFetchAction));
            const hasAccess = await dispatch(canAccessToApplication());
            if (hasAccess) {
                await dispatch(continueToApplication(originalUser, {
                    continueAction
                }));
            }
            return Promise.resolve();
        }
        if (representativeFor) {
            await dispatch(resolveDelegations({
                continueAction,
                createFetchAction,
                createFetchActionWithRepresentedUser,
                getIsOriginalUserFetchLoaded
            }));
            return Promise.resolve();
        }
        await dispatch(initDelegationScreen({
            continueAction,
            createFetchAction
        }));
    };
